import { IListagemDeCustos } from "../../../Interfaces/AssistenciaTecnica/CustoOficialRelatoriosBI/CustoOficialRelatoriosBI";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListagemDeCustosService() {
    return Service(
        Axios.get<Array<IListagemDeCustos>>(
            "/assistenciatecnica/custos/listagemdecustos"
        )
    );
}

export async function CadastroDeCustosService(requestBody: IListagemDeCustos) {
    return Service(
        Axios.post("/assistenciatecnica/custos/cadastrodecustos", requestBody)
    );
}

export async function AtualizacaoDeCustosService(
    requestBody: Array<IListagemDeCustos>
) {
    return Service(
        Axios.patch(
            "/assistenciatecnica/custos/atualizacaodecustos",
            requestBody
        )
    );
}

export async function getCustosService(ID_CUSTO: number) {
    return Service(
        Axios.get<IListagemDeCustos>(
            `/assistenciatecnica/custos/getcustos?ID_CUSTO=${ID_CUSTO}`
        )
    );
}

export async function RemocaoDeCustosService(ID: number) {
    return Service(
        Axios.delete("/assistenciatecnica/custos/remocaodecustos?ID=" + ID)
    );
}
